import React from 'react'
import PropTypes from 'prop-types'

import {AsyncDropdownSelect} from '../DropdownSelect'

const loadOptions = async (inputValue) => {
  if (inputValue.length < 3) {
    return []
  }

  const resp = await fetch(
    `/api/invoices/search?invoice_number=${encodeURIComponent(inputValue)}`,
  )
  const data = await resp.json()

  return data.invoices.map((invoice) => {
    return {
      label: invoice.invoice_number,
      value: invoice.id,
    }
  })
}

const InvoiceFilter = ({value, onChange}) => {
  return (
    <AsyncDropdownSelect
      loadOptions={loadOptions}
      name="invoice"
      value={value}
      noOptionsMessage={({inputValue}) => {
        if (inputValue.length < 3) {
          return 'Start typing to search...'
        }
        return 'No invoices found'
      }}
      placeholder="Invoice number"
      onChange={onChange}
    />
  )
}

InvoiceFilter.defaultProps = {
  value: undefined,
  onChange: () => {},
}

InvoiceFilter.propTypes = {
  value: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  onChange: PropTypes.func,
}

export default InvoiceFilter
